<template>
  <color-editor v-model='value' />
</template>

<script>
import { abstractField } from "vue-form-generator";
import ColorEditor from './ColorEditor.vue';
export default {
  mixins: [ abstractField ],
  data() {
    return {
    }
  },
  components:{
    ColorEditor
  },
  methods: {
  },
  computed:{
  },
  watch:{
  }
}
</script>

